import { ReactNode } from 'react'

import Box from 'components/atomic/atoms/box'
import GrafbaseHead, {
  GrafbaseHeadProps,
} from 'components/atomic/molecules/head'
import LayoutWebsiteNavbar from 'components/pages/@layouts/layout-website/navbar'
import Footer from 'components/pages/@shared/footer'

import { FCC } from 'types/react'

type Props = {
  meta?: GrafbaseHeadProps
  customMobileLinks?: ReactNode
  paddingTop?: boolean
  paddingBottom?: boolean
  minHeight?: boolean
  hideOverflowX?: true
}

const LayoutWebsite: FCC<Props> = props => {
  const {
    meta,
    customMobileLinks,
    children,
    paddingTop = true,
    paddingBottom = true,
    minHeight = true,
    hideOverflowX,
  } = props

  return (
    <>
      {!!meta && <GrafbaseHead {...meta} />}
      <Box
        css={{
          minHeight: '$full',
          bgc: '$base',
        }}
      >
        <LayoutWebsiteNavbar customMobileLinks={customMobileLinks} />
        <Box
          as="main"
          css={{
            flex: 1,
            pt: paddingTop ? '$28' : 'unset',
            pb: paddingBottom ? '$28' : 'unset',
            minHeight: minHeight ? '100vh' : 'unset',
            overflowX: hideOverflowX ? 'hidden' : undefined,

            '--scale': 'calc(1px - (375px - 100dvw) / 375)',
            '@md': {
              '--scale': 'calc(1px - (1280px - min(100dvw, 1280px)) / 1232)',
            },
          }}
        >
          {children}
        </Box>
        <Footer />
      </Box>
    </>
  )
}

export default LayoutWebsite
